import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TsPipesModule } from 'tsui';
import { GalleryItem, GalleryModule, GalleryState, ImageItem } from 'ng-gallery';
import { Image } from 'app/modules/projects/projects.types';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { AsyncPipe } from '@angular/common';
import { PanelHeaderComponent } from '../@shared/panel-header/panel-header.component';
import { PanelContainerComponent } from '../@shared/panel-container/panel-container.component';
import { JupiterPanelComponent } from '../jupiter-panel.component';

@Component({
  selector: 'jupiter-panel-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    MatLegacyTooltipModule,
    MatLegacyButtonModule,
    MatLegacyProgressBarModule,
    TsPipesModule,
    GalleryModule,
    AsyncPipe,
    PanelContainerComponent,
    PanelHeaderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagesPanelComponent extends JupiterPanelComponent<any> implements OnInit {
  allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];

  private currentGalleryIndex = 0;

  ngOnInit(): void {
    super.ngOnInit();
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];

    if (this.allowedFormats.indexOf(file.type) === -1) {
      this.tsSnackbarService.open('Invalid file format. Please upload a JPEG, PNG, or GIF file', 'error');
    } else {
      this.dataUpdated.emit({ model: this.model, origin: this.panelDef, data: { file, mode: 'add' } });
    }
  }

  deletePhoto(): void {
    this.dataUpdated.emit({
      model: this.model,
      origin: this.panelDef,
      data: { mode: 'delete', id: this.model.images[this.currentGalleryIndex].id },
    });
  }

  transformToGalleryItems(model: any): GalleryItem[] {
    return (model?.images ?? [])
      .filter((image: Image) => image.list_image_url && image.original_image_url)
      .map((image: Image) => new ImageItem({ src: image.original_image_url, thumb: image.list_image_url }));
  }

  onIndexChange(event: GalleryState): void {
    this.currentGalleryIndex = event.currIndex;
  }

  onSaveLayout(): void {
    this.panelDef = {
      ...this.panelDef,
      meta: this.panelDef.meta,
    };

    super.onSaveLayout();
  }
}
